import { apiDelete, apiGet, apiPost, apiPut } from './api-service';
import { getUserDetails } from './session-service';

export async function getAll() {
    try {
        const response = await apiGet('core', `employee`);
        return response.content;
    } catch (e) { }
}

export async function getEmployee(id?: string) {
    try {
        if (!id) {
            id = getUserDetails().client_id;
        }
        const response = await apiGet('core', `employee/${id}`);
        return response.content;
    } catch (e) {
        return {};
    }
}

export async function addEnrolment(newDetails: any) {
    try {
        const response = await apiPost('core', `enrolment`, newDetails);
        return response;
    } catch (e) { }
}


export async function addEmployee(newDetails: any) {
    try {
        const response = await apiPost('core', `employee`, newDetails);
        return response;
    } catch (e) { }
}

export async function updateEmployee(newDetails: any, id?: string) {
    try {
        if (!id) {
            id = getUserDetails().client_id;
        }
        const response = await apiPut('core', `employee/${id}`, newDetails);

        return response;
    } catch (e) { }
}

export async function removeEmployee(id: any) {
    try {

        return await apiDelete('core', `employee/${id}`);
    } catch (e) { }
}

export async function addClientAdmin(newDetails: any) {
    try {
        const response = await apiPost('core', `client_admin`, newDetails);
        return response;
    } catch (e) { }
}

export async function updateClientAdmin(newDetails: any, id?: string) {
    try {
        if (!id) {
            id = getUserDetails().client_id;
        }
        const response = await apiPut('core', `client_admin/${id}`, newDetails);

        return response;
    } catch (e) { }
}

export async function removeClientAdmin(id: any) {
    try {

        return await apiDelete('core', `client_admin/${id}`);
    } catch (e) { }
}